export const menuKeys = {
	index: ["public", "menu"],
};
